import { createFileRoute } from "@tanstack/react-router";

import { LearningBrain } from "../features/admin/LearningBrain";
import { useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/admin/learning")({
  component: TabRoute,
});

function TabRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <LearningBrain key={me.data.user.id} me={me.data} />;
}
